import React from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import HandleErrorService from '../../app/service/handleErrorService'
import AuthService from '../../app/service/authService'
import GeneralServices from "../../app/service/generalServices";
import CustomHighlighter from '../customHighlighter'
import EmpresaService from '../../app/service/central/empresaService'
import ConstantsUtil from '../../context/constantsUtil'
import TooltipButton from '../tooltipButton'
import LoginService from '../../app/service/loginService'
import * as popUp from '../toastr'
import SyncEmpresaNFsVendaDialog from './syncEmpresaNFsVendaDialog'
import CentralService from '../../app/service/central/centralService'
import NotificacaoService from '../../app/service/central/notificacaoService'
import TableFilters from '../tableFilters'

class EmpresasTable extends React.Component {

    constructor(){
        super()
        this.dt = React.createRef()
        this.tableFilters = new TableFilters();

        // this.grupoDeEmpresasService = new GrupoDeEmpresasService()
        this.empresaService = new EmpresaService()
        this.loginService = new LoginService()
        this.centralService = new CentralService()
        this.notificacaoService = new NotificacaoService()
        this.generalServices = new GeneralServices()
    }

    state = {

        empresasList: [],
        loading: false,
        empresaToSyncNFVendas: {},
        displaySyncNFVendasDialog: false,

    }

    componentDidMount(){
        this.search()
    }

    search = () => {
        this.setState({loading: true})
        this.empresaService.getAllEmpresas()
        .then(response => {
            let empresasList = response.data
            this.trataResponse(empresasList)
            if(this.props.onlyActive){
                empresasList = empresasList.filter(empresa => empresa.ativa)
            }
            this.setState({empresasList})
            this.setState({loading: false})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({loading: false})
        })
    }

    trataResponse = (empresasList) => {
        empresasList.forEach(empresa => {
            empresa.ativaSistemaString = empresa.ativa ? "Sim" : "Não"
            empresa.ativaNfStockMercadoriasString = empresa.ativoNfStock ? "Sim" : "Não"
            empresa.ativaNfStockNfseString = empresa.ativoNfStockNfse ? "Sim" : "Não"
        })
    }

    changeContextPath = (empresa) => {
        AuthService.changeCurrentContextPath(empresa.contextPath)
        window.location.reload()
    }

    filter(){
        return this.state.empresasList.filter(empresa => GeneralServices.includeString(empresa.nome, this.props.searchText))
    }

    editEmpresa = empresa => {
        this.props.edit(empresa)
    }

    openSyncNFVendasDialog = empresa => {
        this.setState({empresaToSyncNFVendas: empresa})
        this.setState({displaySyncNFVendasDialog: true})
    }

    changeStatusEmpresa = empresa => {
        this.setState({loading: true})
        this.empresaService.changeStatus(empresa)
        .then(response => {
            popUp.successPopUp(`Empresa ${empresa.ativa ? 'inativada' : 'ativada'} com sucesso!`)
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    loginToEmpresa = empresa => {
        let currentPathName = window.location.pathname
        this.loginService.loginToEmpresa(empresa.tenantName)
        .then(async response => {
            let user = response.data
            this.generalServices.completaLogin(user, this.props.context, currentPathName, true);
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    conferePagamentosDia = (empresa) => {
        this.setState({loading: true})
        this.notificacaoService.conferePagamentosDia([empresa])
        .then(response => {
            popUp.successPopUp("Pagamentos conferidos com sucesso")
            this.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })        
    }

    isAdvancedView = () => {
        return this.props.context && this.props.context.perfil && this.props.context.perfil.isAdmin && !this.props.disableEditColumn
    }

    render() {

        const renderHighlightNome = (rowData) => {

            return(
                <CustomHighlighter
                    searchWords={[this.props.searchText]}
                    textToHighlight={rowData.nome}
                />
            )
        }

        const renderWorkerColumn = () => {
            if(this.isAdvancedView()){
                return (
                    <Column field="worker.contextPath" header="Worker" sortable
                        style ={ {width: '100px'} }
                        filter filterElement={workerFilterElement}
                    />
                )
            }
        }

        const actionBodyEntrar = (empresa) => {
            if(empresa.id === ConstantsUtil.idEmpresaGrupoSistema){
                return;
            }
            return (
                <React.Fragment>
                    <TooltipButton
                        tooltip = {`Trocar para ${empresa.nome}`}
                        icon="pi pi-sign-in"
                        onClick={() => this.loginToEmpresa(empresa)}
                    />
                </React.Fragment>
            );
        }

        const renderAcoesColumn = () => {
            if(this.isAdvancedView()){
                return (
                    <Column
                        header="Ações"
                        style ={ {width: '180px'} }
                        body={actionBody}
                    />   
                )
            }
        }

        const renderEditarEmpresaButton = (empresa) => {
            if(empresa.ativa)
            return (
                <TooltipButton
                    className={"p-button-rounded p-mr-2 p-button-success right-button"}
                    tooltip = "Editar Empresa"
                    tooltipOptions={{
                        className: 'custom-tooltip',
                        position: 'left'
                    }}          
                    onClick={() => this.editEmpresa(empresa)}
                />
                
            )
        }

        const renderChangeStatusEmpresaButton = (empresa) => {
            return(
                <TooltipButton
                    className={`p-button-rounded p-mr-2 right-button ${empresa.ativa ? 'p-button-danger' : ''}`}
                    icon = {empresa.ativa ? "pi pi-times" : "pi pi-check"}
                    tooltip = {
                        empresa.ativa ?
                        `Inativar Empresa.\nOs dados da empresa continuarão armazenados, mas não será permitido realizar login nela.\nPoderá ser reativada posteriormente.`
                        : `Ativar Empresa.`
                    }
                    tooltipOptions={{
                        className: 'custom-tooltip',
                        position: 'left'
                    }}                    
                    onClick={() => this.changeStatusEmpresa(empresa)}
                />
            )
        }

        const renderSyncVendas = (empresa) => {
            if(empresa.ativa)
            return(
                <TooltipButton
                    className={`p-button-rounded p-mr-2 right-button`}
                    icon = {"pi pi-link"}
                    tooltip = {"Configurar sincronização para importação de notas de venda com sistema emissor"}
                    tooltipOptions={{
                        className: 'custom-tooltip',
                        position: 'left'
                    }}                    
                    onClick={() => this.openSyncNFVendasDialog(empresa)}
                />
            )
        }

        // const renderConferePagamentosDia = (empresa) => {
        //     if(empresa.ativa)
        //     return(
        //         <TooltipButton
        //             className={`p-button-rounded p-mr-2 right-button p-button-warning`}
        //             icon = {"pi pi-wallet"}
        //             tooltip = {"Gerar notificações de pagamento para o dia atual"}
        //             tooltipOptions={{
        //                 className: 'custom-tooltip',
        //                 position: 'left'
        //             }}                    
        //             onClick={() => this.conferePagamentosDia(empresa)}
        //         />
        //     )
        // }

        const renderInformarCertificadoDigital = (empresa) => {
            if(empresa.ativa)
            return(
                <TooltipButton
                    className={`p-button-rounded p-mr-2 right-button p-button-warning`}
                    icon = {"pi pi-key"}
                    tooltip = {"Informar Certificado Digital"}
                    tooltipOptions={{
                        className: 'custom-tooltip',
                        position: 'left'
                    }}                    
                    // onClick={() => this.conferePagamentosDia(empresa)}
                />
            )
        }

        const actionBody = (empresa) => {
            if(empresa.id === ConstantsUtil.idEmpresaGrupoSistema){
                return;
            }
            return (
                <React.Fragment>
                    {renderEditarEmpresaButton(empresa)}
                    {renderChangeStatusEmpresaButton(empresa)}
                    {renderSyncVendas(empresa)}
                    {/* {renderConferePagamentosDia(empresa)} */}
                    {renderInformarCertificadoDigital(empresa)}
                </React.Fragment>
            );
        }

        const renderSyncNFsVendaDialog = () => {
            if(this.state.displaySyncNFVendasDialog){
                return(
                    <SyncEmpresaNFsVendaDialog
                        visible={this.state.displaySyncNFVendasDialog}
                        empresa={this.state.empresaToSyncNFVendas}
                        hideDialog = {() => this.setState({displaySyncNFVendasDialog: false})}
                        search={this.search}
                    />
                )
            }
        }

        const nomeFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNome,
            this.filter(),
            "selectedNome",
            (name, value) => this.setState({[name]: value}),
            'nome',
            '100%',
            "Nome"
        )

        const nomeSimplificadoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNomeSimplificado,
            this.filter(),
            "selectedNomeSimplificado",
            (name, value) => this.setState({[name]: value}),
            'nomeSimplificado',
            '100%',
            "Nome Simplificado"
        )

        const nomeGrupoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedGrupo,
            this.filter(),
            "selectedGrupo",
            (name, value) => this.setState({[name]: value}),
            'nomeGrupo',
            '100%',
            "Grupo"
        )

        const cnpjFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedCnpj,
            this.filter(),
            "selectedCnpj",
            (name, value) => this.setState({[name]: value}),
            'cnpj',
            '100%',
            "CNPJ"
        )

        const ativaSistemaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedAtivaSistema,
            this.filter(),
            "selectedAtivaSistema",
            (name, value) => this.setState({[name]: value}),
            'ativaSistemaString',
            '100%',
            "Ativa"
        )

        const ativaNfStockMercadoriasFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedAtivaNfStockMercadorias,
            this.filter(),
            "selectedAtivaNfStockMercadorias",
            (name, value) => this.setState({[name]: value}),
            'ativaNfStockMercadoriasString',
            '100%',
            "Ativa"
        )

        const ativaNfStockNfseFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedAtivaNfStockNfse,
            this.filter(),
            "selectedAtivaNfStockNfse",
            (name, value) => this.setState({[name]: value}),
            'ativaNfStockNfseString',
            '100%',
            "Ativa"
        )

        const nfStockLabelFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNfStockLabel,
            this.filter(),
            "selectedNfStockLabel",
            (name, value) => this.setState({[name]: value}),
            'nfstockLabel',
            '100%',
            "Ativa"
        )

        const workerFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedWorker,
            this.filter(),
            "selectedWorker",
            (name, value) => this.setState({[name]: value}),
            'worker.contextPath',
            '100%',
            "Worker"
        )

        return (
            <div className="datatable-crud-demo">
            <div className="card">

                <DataTable
                    ref={this.dt}
                    value={this.filter()}
                    className="p-datatable-sm small-font"
                    rowHover
                    emptyMessage="Não há Empresas cadastradas."
                    // selection={this.state.selectedContasBancaria}
                    // onSelectionChange={this.handleSelectionChange}
                    scrollable
                    // scrollHeight="500px"
                    loading={this.state.loading || this.props.loading}
                    dataKey="cnpj"
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.filter() ? this.filter().length : '')}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} Empresas"
                >

                    <Column field="nome" header="Nome" sortable
                        style ={ {width: '150px'} }
                        body = {renderHighlightNome}
                        filter filterElement={nomeFilterElement}
                    />

                    <Column field="nomeSimplificado" header="Nome Simplificado" sortable
                        style ={ {width: '150px'} }
                        filter filterElement={nomeSimplificadoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeSimplificado, rowIndex)}
                    />

                    <Column field="nomeGrupo" header="Grupo" sortable
                        style ={ {width: '100px'} }
                        filter filterElement={nomeGrupoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nomeGrupo, rowIndex)}
                        />

                    <Column field="cnpj" header="CNPJ" sortable 
                        style ={ {width: '100px'} }
                        filter filterElement={cnpjFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.cnpj, rowIndex)}
                    />

                    <Column field="ativaSistemaString" header="Ativa no Sistema" sortable
                        style ={ {width: '70px'} }
                        filter filterElement={ativaSistemaFilterElement}
                        body={rowData => {
                            return GeneralServices.renderStyledColorTableColumn(rowData.ativa ? 'Sim' : 'Não', rowData.ativa)
                        }}
                    />

                    <Column field="ativaNfStockMercadoriasString" header="Ativo NFStock (Mercadorias)" sortable
                        style ={ {width: '75px'} }
                        filter filterElement={ativaNfStockMercadoriasFilterElement}
                        body={rowData => {
                            return GeneralServices.renderStyledColorTableColumn(rowData.ativoNfStock ? 'Sim' : 'Não', rowData.ativoNfStock)
                        }}                     
                    />

                    <Column field="ativaNfStockNfseString" header="Ativo NFStock (Serviços)" sortable
                        style ={ {width: '70px'} }
                        filter filterElement={ativaNfStockNfseFilterElement}
                        body={rowData => {
                            return GeneralServices.renderStyledColorTableColumn(rowData.ativoNfStockNfse ? 'Sim' : 'Não', rowData.ativoNfStockNfse)
                        }}                     
                    />

                    {/* <Column field="syncApiNFsVenda" header="Sincronização com API de vendas"
                        sortable
                        style ={ {width: '70px'} }
                        // body={rowData => rowData.ativoNfStock ? 'Sim' : 'Não'}
                        body={rowData => {
                            return GeneralServices.renderStyledColorTableColumn(rowData.syncApiNFsVenda ? 'Sim' : 'Não', rowData.syncApiNFsVenda)
                        }}                     
                    /> */}

                    <Column field="nfstockLabel" header="Descrição no NFStock" sortable
                        style ={ {width: '100px'} }
                        filter filterElement={nfStockLabelFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.nfstockLabel, rowIndex)}
                    />

                    {renderWorkerColumn()}

                    <Column
                        header="Entrar"
                        style ={ {width: '100px'} }
                        body={actionBodyEntrar}
                    />                    

                    {renderAcoesColumn()}

                </DataTable>

                {renderSyncNFsVendaDialog()}

            </div>

            </div>
        )
    }

}

export default EmpresasTable